// Utility functions for date handling with Madrid timezone

/**
 * Format date for Madrid timezone
 * @param {string|Date} dateInput - Date string or Date object
 * @param {Object} options - Formatting options
 * @returns {string} Formatted date string
 */
export const formatMadridDate = (dateInput, options = {}) => {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  
  const defaultOptions = {
    timeZone: 'Europe/Madrid',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...options
  };

  return date.toLocaleDateString('es-ES', defaultOptions);
};

/**
 * Format datetime for Madrid timezone
 * @param {string|Date} dateInput - Date string or Date object
 * @param {Object} options - Formatting options
 * @returns {string} Formatted datetime string
 */
export const formatMadridDateTime = (dateInput, options = {}) => {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  
  const defaultOptions = {
    timeZone: 'Europe/Madrid',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    ...options
  };

  return date.toLocaleString('es-ES', defaultOptions);
};

/**
 * Get current Madrid timezone date as ISO string
 * @returns {string} ISO string with Madrid timezone offset
 */
export const getCurrentMadridISO = () => {
  const now = new Date();
  
  // Get Madrid time
  const madridTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
  
  // Calculate offset
  const offset = madridTime.getTime() - now.getTime();
  const madridDate = new Date(now.getTime() + offset);
  
  return madridDate.toISOString();
};

/**
 * Format date for display in contracts table
 * @param {string|Date} dateInput - Date string or Date object
 * @returns {string} Formatted date string (DD/MM/YYYY)
 */
export const formatContractDate = (dateInput) => {
  return formatMadridDate(dateInput, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

/**
 * Format datetime for contact created dates
 * @param {string|Date} dateInput - Date string or Date object
 * @returns {string} Formatted datetime string (DD/MM/YYYY HH:mm)
 */
export const formatContactDateTime = (dateInput) => {
  return formatMadridDateTime(dateInput, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};